import { render, staticRenderFns } from "./OperaMemberDetail.vue?vue&type=template&id=5127b28e&scoped=true&"
import script from "./OperaMemberDetail.vue?vue&type=script&lang=js&"
export * from "./OperaMemberDetail.vue?vue&type=script&lang=js&"
import style0 from "./OperaMemberDetail.vue?vue&type=style&index=0&id=5127b28e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5127b28e",
  null
  
)

export default component.exports